module.exports = __webpack_public_path__ + "static/media/Correct.d6476e4f.svg";